// src/utils/crypto.js
import CryptoJS from 'crypto-js';

const SECRET_KEY = '6k2s95cMYtgR9ephfDCaIBq2dS1BIYzL'; // Replace with a secure key

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

export const decryptData = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const encryptPayload = (data) => {
  const msgString = CryptoJS.enc.Utf8.parse(data);
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(msgString, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
    iv: iv,
  });
  let returnValue = encrypted.toString();
  returnValue += '.' + CryptoJS.enc.Base64.stringify(iv);

  return returnValue;
};

export const decryptPayload = (data) => {
  const payload = data.split('.');
  const iv = payload[1];
  const decryptedData = payload[0];
  const decrypted = CryptoJS.AES.decrypt(decryptedData, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
    iv: CryptoJS.enc.Base64.parse(iv),
  });
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};
